import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@prcins/environments';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ContactInfoService = /** @class */ (function () {
    function ContactInfoService(http) {
        this.http = http;
        this.baseUrl = environment.BASE_URL; // Adjust this to your actual API endpoint
    }
    ContactInfoService.prototype.getContactInfoFromServer = function (userId) {
        return this.http.get(this.baseUrl + "/account/getContactInfo/" + userId);
    };
    /**
     * Returns an observable with { shouldShow: boolean, contactInfo: any }
     * Handles all popup logic and provides contact info for pre-population.
     */
    ContactInfoService.prototype.getContactInfo = function (userId) {
        var _this = this;
        return new Observable(function (observer) {
            _this.getContactInfoFromServer(userId).subscribe(function (data) {
                var contactInfo = data || {};
                var phoneNumber = contactInfo.phoneNumber;
                var email = contactInfo.email;
                //const doNotShowAgain = contactInfo.doNotShowAgain;
                var shouldShow = true;
                if (phoneNumber && email) {
                    shouldShow = false;
                }
                else if ((!phoneNumber || !email)) {
                    shouldShow = true;
                }
                observer.next({ shouldShow: shouldShow, contactInfo: contactInfo });
                observer.complete();
            }, function () {
                observer.next({ shouldShow: true, contactInfo: {} });
                observer.complete();
            });
        });
    };
    ContactInfoService.prototype.updateContactInfo = function (userId, contactInfo) {
        // contactInfo should contain: email, phoneNumber, mobileIndicator, doNotShowAgain
        return this.http.post(this.baseUrl + "/account/updateContactInfo/" + userId, contactInfo);
    };
    ContactInfoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContactInfoService_Factory() { return new ContactInfoService(i0.ɵɵinject(i1.HttpClient)); }, token: ContactInfoService, providedIn: "root" });
    return ContactInfoService;
}());
export { ContactInfoService };
